import React from 'react';
import Acord27Form from './Acord27Form';
import type { Acord27FormRef } from './Acord27Form';
import type { StoredCoverage, StoredPolicy } from '../../utils/parseAcord27StoredCoverages';

export type { Acord27FormRef };

interface Acord27With101FormProps {
  selectedPolicies?: string[];
  insuredId?: string;
  selectedLocationLabel?: string;
  editCoverages?: StoredCoverage[];
  editPolicies?: StoredPolicy[];
}

const Acord27With101Form = React.forwardRef<Acord27FormRef, Acord27With101FormProps>(
  function Acord27With101Form({ selectedPolicies = [], insuredId = '', selectedLocationLabel = '', editCoverages, editPolicies }, ref) {
    return <Acord27Form ref={ref} showAcord101 selectedPolicies={selectedPolicies} insuredId={insuredId} selectedLocationLabel={selectedLocationLabel} editCoverages={editCoverages} editPolicies={editPolicies} />;
  }
);

export default Acord27With101Form;
